import React, { Component } from "react";
import { toast } from "react-toastify";
import { Modal, Button, Loading } from "carbon-components-react";
import { EditableHeader, CardLoader, Breadcrumb } from "../../../../components";
import {
  insertDmService,
  getByDmService
} from "../../../../services/Api";
import adminCampaignPromoters from "../../../../fixtures/adminCampaignPromoters.json";
import PeriodCampaign from "../../../../components/trades/campaign/PeriodCampaign";
import DinamicAndBudgets from "../../../../components/trades/campaign/DinamicsAndBudgts";
import UnitsAndStores from "../../../../components/campaigns/UnitsAndStores";
import NoteCampaign from "../../../../components/trades/campaign/NoteCampaign";
import Merchandising from "../../../../components/trades/campaign/Merchandising";

class CampaingnPromoter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isLoading: true,
      isSaving: false,
      successModel: false,
      nrPedido: null,
      mdDelete: false,
      dataForm: { descricao: props.match.params.name || null }
    };
  }

  componentWillMount = () => {
    this.loadCampaign();
  }

  loadCampaign = async () => {
    const { match } = this.props;
    if (match.params.id) {
      try {
        const data = await getByDmService(
          "Pedido/GetCampanhaPromocional",
          match.params.id
        );
        await console.log("teste")
        await console.log(data)
        this.setState({ data, isLoading: false });
      } catch (e) {
        toast.error("Ocorreu um erro ao carregar as campanhas");
        this.setState({ data: {}, isLoading: false });
      }
    }
    this.setState({ isLoading: false });
  };

  saveName = title => {
    this.setState({
      formData: { descricao: title }
    });
  };

  saveStep = stepData => {
    this.setState(prevState => ({
      ...prevState,
      dataForm: {
        ...prevState.dataForm,
        ...stepData
      }
    }));
  };

  canFinishOrder = () => {
    const { dataForm } = this.state;
    return (
      dataForm.salvouPeriodo &&
      dataForm.salvouDinamicaBudget &&
      dataForm.salvouUnidades &&
      dataForm.salvouMerchandising &&
      dataForm.salvouObservacao
    );
  };

  saveOrder = () => {
    if (!this.canFinishOrder()) {
      toast.warn("Verifique se todos os campos foram preenchidos");
    } else {
      const { dataForm } = this.state;
      this.setState({ isSaving: true });
      insertDmService("/Pedido/GeraPedidoPromocional/", dataForm)
        .then(value => {

          this.setState({ isSaving: false, nrPedido: value });
          this.toggleSuccessModal();
        })
        .catch(() => {
          toast.error("Ocorreu um erro ao finalizar o pedido");
          this.setState({ isSaving: false });
        });
    }
  };

  toggleSuccessModal = () => {
    this.setState(prevState => ({
      successModel: !prevState.successModel
    }));
  };

  toogleDeleteModal = () => {
    this.setState(prevState => ({
      mdDelete: !prevState.mdDelete
    }));
  };

  finishOrder = () => {
   window.location.href = '/trade/campanhas'
  };

  deleteORder = () => {
    const { history } = this.props;
    history.goBack();
  };

  renderContent = () => {
    const { isLoading, dataForm } = this.state;

    if (isLoading) {
      return <CardLoader lines={5} />;
    }

    return (
      <div>
        <EditableHeader
          titleDefault={dataForm.descricao}
          onSave={this.saveName}
        />
        {adminCampaignPromoters.map(item => this.renderComponent(item))}
      </div>
    );
  };

  renderComponent = step => {
    const { dataForm } = this.state;
    const { data } = this.state;
    const campaignItem = data.itensCampanhaPromocional > 0;
    const hasCampaignItem = campaignItem.length > 0;
    const validate = true;
    switch (step.form) {
      case "periodo":
        return (
          <PeriodCampaign
            key={step.id}
            buttonIn={validate}
            step={step}
            campaignItem={hasCampaignItem && campaignItem[0]}
            data={hasCampaignItem && campaignItem[0]}
            saveStep={this.saveStep}
            
          />
        );
      case "budget":
        return (
          <DinamicAndBudgets
            key={step.id}
            step={step}
            campaignItem={hasCampaignItem && campaignItem[0]}
            data={hasCampaignItem && campaignItem[0]}
            saveStep={this.saveStep}
            buttonIn={validate}
          />
        );
      case "unidades":
        return (
          <UnitsAndStores
            key={step.id}
            step={step}
            campaignItem={hasCampaignItem > 0 && campaignItem[0]}
            list={hasCampaignItem.length > 0 && campaignItem[0].unidadesLojas}
            saveStep={this.saveStep}
            hideActions={!validate}
            showSave={validate}
            titleBtnSave="Avançar"
            salvouUnidades={dataForm.salvouUnidades}
            
          />
        );
      case "merchandising":
        return (
          <Merchandising
            key={step.id}
            step={step}
            campaignItem={hasCampaignItem && campaignItem[0]}
            data={hasCampaignItem && campaignItem[0]}
            saveStep={this.saveStep}
            buttonIn={validate}
          />
        );
      case "observacao":
        return (
          <NoteCampaign
            key={step.id}
            step={step}
            campaignItem={hasCampaignItem && campaignItem[0]}
            data={hasCampaignItem && campaignItem[0]}
            saveStep={this.saveStep}
            buttonIn={validate}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const {
      isLoading,
      isSaving,
      successModel,
      nrPedido,
      mdDelete      
    } = this.state;
    const { history } = this.props;

   
    
    return (
      <div className="promo-campaign-page">
        <Breadcrumb
          title="Campanhas Promocionais"
          description="A realização de campanhas envolvendo sorteio de prêmios, distribuição gratuita de brindes, concursos, exige rigorosa observação às normas, além de estar de acordo com o que determina o Código de Defesa do Consumidor. Por isso é muito importante que você nos passe as informações abaixo, para estarmos dentro da legalidade e identificarmos a melhor campanha pra você!"
          renderLeft={(() => (
            <div
              className="breadcrumb-left-actions pointer"
              onClick={() => history.goBack()}
            >
              <svg width="16" height="14" viewBox="0 0 16 14">
                <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
              </svg>
            </div>
          ))()}
        />
        <section className="content-wrapper content-wrapper--large">
          {this.renderContent()}

          {!isLoading && (
            <div className="v-md-margin">
              <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
                <Button
                  className="bx--btn--full-width"
                  onClick={this.saveOrder}
                >
                  Finalizar pedido
                </Button>
              </div>
              <div className="bx--col-xs-12 bx--col-sm-12 v-sm-margin">
                <Button
                  kind="secondary"
                  className="bx--btn--full-width"
                  onClick={() => this.toogleDeleteModal()}
                >
                  Cancelar Pedido
                </Button>
              </div>
            </div>
          )}
          <div>
            <Modal
              className="bx--modal-secondary-hide"
              open={successModel}
              onRequestSubmit={() => this.finishOrder()}
              modalHeading="Pedido feito com sucesso."
              primaryButtonText="Ok, entendi"
              secondaryButtonText={null}
            >
              <div className="warning-modal-txt">
                <h3>
                  {`Seu pedido ${nrPedido} está sob avaliação.`}
                </h3>
                <p className="font-size-13 v-md-margin">
                  {`A qualquer momento você poderá acompanhá-lo clicando em `}
                  <a className="notifications pointer" href="/pedidos">
                    <i className="assignment" />
                  </a>
                </p>
              </div>
            </Modal>
          </div>
          <div>
            <Modal
              open={mdDelete}
              onRequestSubmit={() => this.deleteORder()}
              onSecondarySubmit={() => this.toogleDeleteModal()}
              onRequestClose={() => this.toogleDeleteModal()}
              modalHeading="Você tem certeza que deseja cancelar este pedido?"
              primaryButtonText="Tenho certeza"
              secondaryButtonText="Cancelar"
            >
              <div className="warning-modal-txt">
                <p>
                  {`Ao clicar em Tenho Certeza, todos os dados preenchidos serão apagados.`}
                </p>
              </div>
            </Modal>
          </div>
          {isSaving && <Loading small />}
        </section>
      </div>
    );
  }
}
export default CampaingnPromoter;



// WEBPACK FOOTER //
// ./src/screens/client/trades/campaings/CampaingnPromoter.jsx